import React, { useState } from "react";
import { Steps, Button, message, Card, Cascader } from "antd";
import First from "./FirstContent";
import SecondContent from "./SecondContent";
import LastContent from "./LastContent";
import "./style.css";

const { Step } = Steps;

const steps = [
  {
    title: "资产配对",
    content: <First />,
  },
  {
    title: "确认资产",
    content: <SecondContent />,
  },
  {
    title: "完成",
    content: <LastContent />,
  },
];

interface Props {
  history: any;
}
const index = (props: Props) => {
  const [current, setCurrent] = useState(0);
  const next = () => {
    setCurrent(current + 1);
  };

  const prev = () => {
    setCurrent(current - 1);
  };
  return (
    <Card className="property">
      <div className="title">资产设置</div>
      <Steps current={current}>
        {steps.map((item) => (
          <Step key={item.title} title={item.title} />
        ))}
      </Steps>
      <div className="steps-content">{steps[current].content}</div>
      <div className="steps-action">
        {current < steps.length - 1 && (
          <Button type="primary" onClick={() => next()}>
            下一步
          </Button>
        )}
        {current === steps.length - 1 && (
          <Button
            type="primary"
            onClick={() => {
              props.history.push("/property");
            }}
          >
            回到首页
          </Button>
        )}
        {current > 0 && (
          <Button style={{ marginLeft: 8 }} onClick={() => prev()}>
            上一步
          </Button>
        )}
      </div>
    </Card>
  );
};

export default index;
